import { ProductJsonLd } from 'next-seo';
import Head from 'next/head';
import { images } from '../../../Constants/ImageUrls';
import { inStockSchema } from '../../../Constants/PdpContants';
import { BrandName } from '../../../Constants/ProductPage';
import { generateTimeString, getReviewJSONLdData } from '../../../Utils/helper';

// import { inStockSchema } from "../../../Constants/PdpContants";

function index(props) {
  const { reviewdata, data } = props;

  const productName =
    'Mylo Adjustable Washable & Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Jungle';
  const { avgRating, ratingCount } = reviewdata?.data || {};
  const aggregateRating = {
    ratingValue: avgRating,
    reviewCount: ratingCount,
  };
  const { ReviewJSONData } = getReviewJSONLdData(reviewdata);
  let reviews = [];
  ReviewJSONData?.map((item) => {
    reviews.push({
      author: item?.username,
      reviewBody: item?.title,
      reviewRating: item?.reviewRating,
    });
  });

  function updateToNext30th(date) {
    // Check if the current date is the 30th
    if (date.getDate() === 30) {
      // Get the current month and year
      let month = date.getMonth();
      let year = date.getFullYear();

      // If it's December, move to January of the next year
      if (month === 11) {
        month = 0; // January
        year += 1; // Next year
      } else {
        month += 1; // Next month
      }

      // Set the new date to the 30th of the next month
      let nextDate = new Date(year, month, 30);

      return nextDate;
    }

    // If it's not the 30th, return the original date
    let year = date.getFullYear();
    let month = date.getMonth();
    let newDate = new Date(year, month, 30);

    return newDate;
  }

  let currentDate = new Date(); // Get current date
  let updatedDate = updateToNext30th(currentDate);

  const { day, year, monthNo } = generateTimeString(updatedDate);
  const expiryDate = `${year}-${monthNo + 1}-${day + 1}`;

  return (
    <>
      {/* <ProductJsonLd
                productName={
                    "Mylo Adjustable Washable & Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Jungle"
                }
                images={[images.diaperImage]}
                offers={{
                    price: 599,
                    priceCurrency: "INR",
                    // availability: inStockSchema,
                }}
            /> */}

      <ProductJsonLd
        productName={productName}
        description={productName}
        brand={BrandName}
        manufacturerName={BrandName}
        manufacturerLogo={images.logo}
        aggregateRating={aggregateRating}
        reviews={reviews}
        offers={[
          {
            price: 599,
            priceCurrency: 'INR',
            availability: inStockSchema,
            priceValidUntil: expiryDate,
            itemCondition: 'NewCondition',
          },
          {
            price: 1299,
            priceCurrency: 'INR',
            availability: inStockSchema,
            priceValidUntil: expiryDate,
            itemCondition: 'NewCondition',
          },
        ]}
        images={[images.diaperImage]}
      />

      <Head>
        <meta name="google" content="notranslate" />
      </Head>
    </>
  );
}

export default index;
